import React from 'react';
import { Option, none, isSome } from 'fp-ts/lib/Option';
import { CalculatorResponse } from '../../model/CalculatorResponse';
import { CalculatorConfig, emptyCalculatorConfig } from '../../model/CalculatorConfig';

export interface CalculatorResultsStore {

    config: CalculatorConfig;
    setConfig: (config: CalculatorConfig) => void;

    results: Option<CalculatorResponse>;
    setResults: (results: Option<CalculatorResponse>) => void;

    secondaryResults: Option<CalculatorResponse>;
    setSecondaryResults: (results: Option<CalculatorResponse>) => void;

    hasResults: () => boolean;

    error: Option<string>;
    setError: (error: Option<string>) => void;

    hasError: () => boolean;

    loading: boolean;
    setLoading: (loading: boolean) => void;




    exportingPdf: boolean;
    setExportingPdf: (exporting: boolean) => void;

    exportingPdfCancelled: boolean;
    setExportingPdfCancelled: (cancelled: boolean) => void;

    pdfUrl: Option<string>;
    setPdfUrl: (url: Option<string>) => void;


    pdfExportError: Option<string>;
    setPdfExportError: (error: Option<string>) => void;


    restart(): void;
}


const emptyStore: CalculatorResultsStore = {
    results: none,
    secondaryResults: none,
    error: none,
    loading: false,
    config: emptyCalculatorConfig,
    setConfig: (_c: CalculatorConfig) => { return; },
    setResults: (_r: Option<CalculatorResponse>) => { return; },
    setSecondaryResults: (_r: Option<CalculatorResponse>) => { return; },
    hasResults: () => false,
    setError: (_r: Option<string>) => { return; },
    hasError: () => false,
    setLoading: (_l: boolean) => { return; },

    exportingPdf: false,
    setExportingPdf: (_e: boolean) => { return; },

    exportingPdfCancelled: false,
    setExportingPdfCancelled: (_c: boolean) => { return; },

    pdfUrl: none,
    setPdfUrl: (_url: Option<string>) => { return; },


    pdfExportError: none,
    setPdfExportError: (_error: Option<string>) => { return; },

    restart: () => { return; }
};

export class ResultStateStore implements CalculatorResultsStore {
    config: CalculatorConfig;
    setConfig: (config: CalculatorConfig) => void;
    results: Option<CalculatorResponse>;
    setResults: (results: Option<CalculatorResponse>) => void;
    secondaryResults: Option<CalculatorResponse>;
    setSecondaryResults: (results: Option<CalculatorResponse>) => void;
    error: Option<string>;
    setError: (error: Option<string>) => void;
    loading: boolean;
    setLoading: (loading: boolean) => void;
    exportingPdf: boolean;
    setExportingPdf: (exporting: boolean) => void;

    exportingPdfCancelled: boolean;
    setExportingPdfCancelled: (cancelled: boolean) => void;

    pdfUrl: Option<string>;
    setPdfUrl: (url: Option<string>) => void;

    pdfExportError: Option<string>;
    setPdfExportError: (error: Option<string>) => void;

    constructor(
        config: CalculatorConfig,
        setConfig: (config: CalculatorConfig) => void,
        results: Option<CalculatorResponse>,
        setResults: (results: Option<CalculatorResponse>) => void,
        secondaryResults: Option<CalculatorResponse>,
        setSecondaryResults: (results: Option<CalculatorResponse>) => void,
        error: Option<string>,
        setError: (error: Option<string>) => void,
        loading: boolean,
        setLoading: (loading: boolean) => void,

        exportingPdf: boolean,
        setExportingPdf: (exporting: boolean) => void,
        exportingPdfCancelled: boolean,
        setExportingPdfCancelled: (cancelled: boolean) => void,

        pdfUrl: Option<string>,
        setPdfUrl: (url: Option<string>) => void,

        pdfExportError: Option<string>,
        setPdfExportError: (error: Option<string>) => void
    ) {
        this.config = config;
        this.setConfig = setConfig;
        this.results = results;
        this.setResults = setResults;
        this.secondaryResults = secondaryResults;
        this.setSecondaryResults = setSecondaryResults;
        this.error = error;
        this.setError = setError;
        this.loading = loading;
        this.setLoading = setLoading;

        this.exportingPdf = exportingPdf;

        this.setExportingPdf = setExportingPdf;

        this.exportingPdfCancelled = exportingPdfCancelled;
        this.setExportingPdfCancelled = setExportingPdfCancelled;

        this.pdfUrl = pdfUrl;
        this.setPdfUrl = setPdfUrl;

        this.pdfExportError = pdfExportError;
        this.setPdfExportError = setPdfExportError;

    }

    hasResults() {
        return isSome(this.results);
    }
    hasError() {
        return isSome(this.error);
    }

    restart() {
        this.setResults(none);
        this.setError(none);
        this.setLoading(false);

        this.setExportingPdf(false);
        this.setExportingPdfCancelled(false);
        this.setPdfUrl(none);
        this.setPdfExportError(none);
    }
}

export const CalculatorResultsContext = React.createContext<CalculatorResultsStore>(emptyStore);
